import {getHomepageData} from '../../../features/Homepage/actions/data';

export function getRecentUpdates() {
    window['GetRecentUpdates'] && window['GetRecentUpdates']();
}

export async function refreshHomePage() {
    await getHomepageData(false);
    console.log('==================== Refreshed New HomePage Data ====================');
}

export function reloadMainMenu() {
    window['reloadMainMenu'] && window['reloadMainMenu']();
}

export function addDeleteFavorites(exec: number, title: string, add: boolean) {
    return (
        window['priApi'] &&
        window['priApi'].addRemoveFavorites &&
        window['priApi'].addRemoveFavorites(exec, title, add ? 1 : 0)
    );
}
